module.exports = __webpack_public_path__ + "img/stock5.9c95c4cb.png";